import Course from "./SingleCourse";
import NavBar from "../../Universal Components/NavBar/NavBar";
import "./Courses.css"

const topics  = [
    "Discrete Math", 
    "Finance", 
    "Linear Algebra",
    "Data Structures",
    "Operating Systems"
]



export default function Courses(){

    let all_courses = topics.map( topic => <Course course_title={topic}/> )

    return (
        <>
            <NavBar/>
            <div className="courses-container">
                {all_courses}
            </div>
        </>
       
    );
}